import React from "react";
import classNames from "classnames";
import { AppButton } from "../../AppButton";
import baseBtn from "../styles.module.scss";
import styles from "./styles.module.scss";

interface Props {
  onClick: () => void;
  className?: string;
  children: React.ReactNode;
}

export const CancelButton: React.FC<Props> = ({ onClick, children, className }) => {
  return (
    <AppButton
      onClick={onClick}
      className={classNames(baseBtn["contacts-btn"], styles["cancel-btn"], className)}
    >
      {children}
    </AppButton>
  );
};
